// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails

import "./src/groups-scroll"
import "./src/index-stages"
import "./src/bion-vendors"
import "./src/b2b-why"
import "./src/b2b-scroll"
import "./src/slider"
import "./src/tests-search"
import "./src/bion-slides"
import "./src/cookie-consent"
import "./src/calc"
import "./src/gallery"
import "./src/async-forms"
import "./src/accessibility-mode"

import "./molecula/molecule-renderer"
import "./molecula-usages/index"

// mobile
import "./src/mobile-hamb"
